import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddSmsContactView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/AddSmsContactView";
import EnterActivationCodeView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/EnterActivationCodeView";
import Classes, { ContactInfo } from "model";
//import EnterActivationCodeAddPhoneView from "components/custom-ui/CustomModal/components/AddContactMethodModal/components/EnterActivationCodeAddPhoneView";
// Steps of the workflow
var steps = [
    AddSmsContactView,
    EnterActivationCodeView
];

/**
 * @function AddPhoneContactMethodModalWorkflow
 * 
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the add phone contact info modal workflow.
 */
export default function AddPhoneContactMethodModalWorkflow(props) {
    // Get the inital state of the workflow
    const controller = useBCMSContext();
    const { workflowType, refresh, values, step } = props;

    BCMSRecord.globalControllerFor(Classes, controller);

    const defaults = { ...getDefaultAddPhone(workflowType, refresh), ...values ?? {} };
    return <Workflow value={ defaults } steps={ steps } step={ step ?? 0 }/>
}
// Return the steps of the workflow
export const getWorkflowStepsAddPhone = () => steps;

export const getDefaultAddPhone = (type, refresh) => {
    return {
        data: {
            info: ContactInfo.init({
                id: ContactInfo.nextID(),
                isPrimary: "false",
                isConfirmed: "false",
                value: ""
            }),

            unconfirmedContacts: []
        },
        ui: {
            workflowType: type,
            refresh
        }
    }
}